import { useEffect } from "react";

import { useIsMobile } from "../../hooks";
import { useDebounceFn } from "../../utils/debounce";
import { LeadsInfoDashboard } from "../LeadsInfoDashboard";
import { useLeadsContext } from "../providers/LeadsProvider";
import {
  LeadHeadLineMetricsTranslatedContent,
  LeadsPageAnalytics,
} from "../types";

type LeadsHeadlineMetricsProps = {
  translatedContent?: LeadHeadLineMetricsTranslatedContent;
  analytics?: LeadsPageAnalytics;
};

export const LeadsHeadlineMetrics = ({
  translatedContent,
  analytics,
}: LeadsHeadlineMetricsProps) => {
  const {
    resources: { stats },
    runResource,
  } = useLeadsContext();
  const isLoading = stats.status === "loading";
  const isMobile = useIsMobile();

  const [debounceTooltipTrack] = useDebounceFn((isMobile: boolean) => {
    analytics?.trackInPogressTooltipHoverEvent(isMobile);
  }, 1000);

  useEffect(() => {
    runResource("stats");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LeadsInfoDashboard
      translatedContent={translatedContent}
      data={stats.data?.headlineMetrics}
      isLoading={isLoading}
      onTrackInProgressTooltipHover={debounceTooltipTrack}
      isMobile={isMobile}
    />
  );
};
